import { NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DialogHeaderComponent } from './dialog-header.component';

@NgModule({
    imports: [DragDropModule, TranslatePipe, TranslateDirective],
    declarations: [DialogHeaderComponent],
    exports: [DialogHeaderComponent]
})
export class DialogHeaderModule {}
